export default "__VITE_ASSET__cba27878__"